// components
import { getHomePath, PATH_APPLY, PATH_STUDENT } from '../../../routes/paths';
import SvgIconStyle from '../../../components/SvgIconStyle';
import { getSection } from '../../../utils/getSection';

const section = getSection(window.location.pathname)

// ----------------------------------------------------------------------

const getIcon = (name) => <SvgIconStyle src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  home: getIcon('ic_home'),
  group: getIcon('ic_group'),
  user: getIcon('ic_user'),
  school: getIcon('ic_school'),
  accounting: getIcon('ic_accounting'),
  receipt: getIcon('ic_receipt'),
  book: getIcon('ic_book'),
  setting: getIcon('ic_setting'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  graph_paper: getIcon('ic_graph_paper'),
  list: getIcon('ic_list'),
  paper_scroll: getIcon('ic_paper_scroll'),
  cash_stack: getIcon('ic_cash_stack'),
  grade: getIcon('ic_grade'),
  records: getIcon('ic_records'),
};

const studentLinks = [
  { title: 'Home', path: PATH_STUDENT.home, icon: ICONS.home },
  { title: 'My Courses', path: PATH_STUDENT.courses, icon: ICONS.book },
  { title: 'My Records', path: PATH_STUDENT.records, icon: ICONS.records },
  { title: 'My Registrations', path: PATH_STUDENT.registration, icon: ICONS.list },
  // { title: 'My Grades', path: PATH_STUDENT.grades, icon: ICONS.grade },
  // { title: 'Curriculum', path: PATH_STUDENT.curriculum, icon: ICONS.paper_scroll },
  { title: 'Billings and Payments', path: PATH_STUDENT.billings, icon: ICONS.cash_stack },
  // { title: 'Tickets', path: PATH_STUDENT.tickets, icon: ICONS.receipt },
  { title: 'Course Reservation', path: '/student/course-reservation', icon: ICONS.graph_paper },
  { title: 'My Activities', path: '/student/exams', icon: ICONS.receipt },
  { title: 'My Profile', path: PATH_STUDENT.settings, icon: ICONS.setting },
]

const applyLinks = [
  { title: 'Home', path: PATH_APPLY.home, icon: ICONS.home },
  { title: 'Profile', path: PATH_APPLY.profile, icon: ICONS.user },
  { title: 'Billings and Payments', path: PATH_APPLY.billings, icon: ICONS.cash_stack },
  { title: 'Applications', path: PATH_APPLY.applications, icon: ICONS.list },
]

const navConfig = section === 'student' ? [{
  items: studentLinks,
},] : [{
  items: applyLinks
}];

export default navConfig;